import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Overview } from 'components/misc'
import { DashboardGrid as Grid, MaterialControlBar } from 'components/layout'
import { EditRpModal } from 'components/modals'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { ACTIVITY_SECTIONS, RP_STATES } from 'constants/enums'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { connect } from 'react-redux'
import styles from '../../../components/layout/MaterialControlBar/material-control-bar.styl'
import { FormattedMessage } from 'react-intl'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

@modal.trigger()
@apiConfiguration()
@apiDashboard.apiResidentialProject()
@connect(({ api }) => ({
  dashboard: api.dashboard
}))
class RPOverview extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    rPValues: PropTypes.object,
    params: PropTypes.object,
    dashboard: PropTypes.object
  }

  handleOpenRp = () => this.props.onOpen(MODALS.EDIT_ACTIVITY, null, null)

  render() {
    const { rPValues } = this.props
    const goal = get(rPValues, 'detail.goal')
    const endDate = get(rPValues, 'detail.endDate')
    const startDate = get(rPValues, 'detail.startDate')
    const locationDetail = get(rPValues, 'detail.locationDetail')
    const note = get(rPValues, 'detail.note')
    const assessorName = get(rPValues, 'detail.assessorName') || get(rPValues, 'detail.assessor.name')
    const assessorEmail = get(rPValues, 'detail.assessorEmail') || get(rPValues, 'detail.assessor.email')
    const canEdit = RP_STATES.in_progress.id === get(rPValues, 'detail.state.value')
    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(rPValues, 'detail'))
    const assessorRegState = get(rPValues, 'detail.assessorRegistrationState')

    let assessorDetailContent = [
      {
        id: '10',
        content: assessorName,
        intlKey: 'label.name',
        label: 'Name',
        ico: 'face'
      }
    ]

    if (!isAssessorManagementEnabled) {
      assessorDetailContent.push(    {
        id: '11',
        content: assessorEmail,
        intlKey: 'label.email',
        label: 'Email',
        ico: 'email'
      })
    }

    if (isAssessorManagementEnabled) {
      assessorDetailContent.push({
        id: '12',
        content: assessorRegState,
        intlKey: 'label.assessor_state',
        label: 'Assessor state',
        ico: 'timer'
      })
    }


    return (
      <Grid.RightInner white>
        {canEdit &&
          <MaterialControlBar
            edit={{
              onClick: this.handleOpenRp,
              label: 'Edit Residential Project',
              intlKey: 'button.residential_project'
            }}
          />}
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Overview
              activitySection={ACTIVITY_SECTIONS.residential_project.id}
              title="Residential Project Details"
              titleKey="moduleTitle.residential_project_details"
              content={[
                {
                  id: '00',
                  content: goal,
                  intlKey: 'label.goal',
                  label: 'Goal',
                  ico: 'flag'
                },
                {
                  id: '01',
                  content: startDate,
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '02',
                  content: endDate,
                  intlKey: 'label.end_date',
                  label: 'End Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '03',
                  content: locationDetail,
                  intlKey: 'label.location',
                  label: 'Location',
                  ico: 'map'
                },
                {
                  id: '04',
                  content: note,
                  intlKey: 'label.note',
                  label: 'Note',
                  ico: 'subject'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Overview
              activitySection={ACTIVITY_SECTIONS.residential_project.id}
              title="Assessor Detail"
              titleKey="moduleTitle.assessor_details"
              content={assessorDetailContent}
            />
          </div>
        </div>

        <div className="col-xs-12 col-sm-6">

          {get(rPValues, 'isAcceptedByAssessor') && <button
            type="button"
            className={styles.clear}
            onClick={() =>
              this.props.onOpen(MODALS.STOP_ASSESSING_SECTION, null, null)}
          >
            <i className={`ico ico--close ${styles.clearIcon}`} />
            <FormattedMessage id='button.stop_assessing_this_activity' defaultMessage='STOP ASSESSING THIS ACTIVITY' />
          </button>}

        </div>

        <EditRpModal
          modalId={MODALS.EDIT_ACTIVITY}
          params={this.props.params}
          residentialProjectId={get(rPValues, 'detail.id')}
          residentialProject={get(rPValues, 'detail')}
        />
      </Grid.RightInner>
    )
  }
}

export default RPOverview
